import css from "styled-jsx/css";
import Colors from "styles/colors";

export const componentStyles = css.global`
  .link-item-component {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0px 16px;
    text-decoration: none;
    color: ${Colors["mud"]};
    transition: color 200ms ease;

    &:hover {
      color: ${Colors["iris"]};
    }
  }
`;
